import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectIsLoading, selectUserCurrency } from 'redux/selectors';
import { Loader } from 'components/Loader/Loader';
import { UniversalTransactions } from './UniversalTransactions/UniversalTransactions';
import { Search } from 'components/Calendar/Search';

import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { SearchComponentPaidStatus } from 'components/Modal/ModalDebt/SearchComponentPaidStatus';

export const filteredTransactions = (data, searchValue) => {
  return data.filter(item => {
    const descriptionMatch =
      item && item.description
        ? item.description.toLowerCase().includes(searchValue.toLowerCase())
        : false;

    const sumMatch =
      item && item.sum && item.sum.toString().includes(searchValue);

    const categoryMatch = item.icon
      .toLowerCase()
      .includes(searchValue.toLowerCase());

    return descriptionMatch || sumMatch || categoryMatch;
  });
};

export const Transaction = ({
  transactions,
  allTransactions,
  tableHeadingSelect,
  deleteType,
  isWalletView,
  setModalDebtEditOpen,
  modalDebtEditOpen,
  overDueType,
  setIsOverdue,
  paidStatusMarker,
  iconDebt,
  debtParent,

  modalPaidStatus,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [isBlurApplied, setIsBlurApplied] = useState(false);

  const isLoading = useSelector(selectIsLoading);
  const currencySymbol = useSelector(selectUserCurrency);
  const { t } = useTranslation();
  const scTheme = useTheme();
  const isDarkShell = scTheme.ui.scheme === 'dark';
  const divRef = useRef(null);
  const isReminderView = deleteType === 'reminder' || tableHeadingSelect === true;
  const isDebtView = deleteType === 'debt';
  const hideSearchForEmptyPlanning = !allTransactions && transactions.length === 0 && (isReminderView || isDebtView);
  const useInternalTableScroll = allTransactions;
  const scrollContainerClass = useInternalTableScroll
    ? `transaction-scrollbar ${isWalletView ? 'max-h-[42vh]' : 'max-h-[55vh]'
    } overflow-y-auto pr-4`
    : '';

  const debtType = iconDebt => {
    if (iconDebt === 'icon-Im-owed') {
      return t('modalDebt.imOwed');
    }
    return t('modalDebt.iOwe');
  };
  const getColorAndIcon = operation => {
    if (operation === 'expense') {
      return {
        color: '#FF1717',
        icon: 'icon-I-owe',
        position: '-',
      };
    }
    if (operation === 'income') {
      return {
        color: '#01AB3A',
        icon: 'icon-Im-owed',
        position: '+',
      };
    }
    if (operation === undefined) {
      return {
        color: '#FF7601',
        position: null,
      };
    }

    return {
      color: '#000000',
      icon: '',
    };
  };

  useEffect(() => {
    const divElement = divRef.current;
    const handleClick = event => {
      if (divElement.contains(event.target)) {
        setSelectedTransactionId(null);
        setIsBlurApplied(false);
      }
    };
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [divRef, setSelectedTransactionId, setIsBlurApplied]);

  if (isWalletView) {
    return (
      <section ref={divRef} className="px-4 pb-4">
        <div
          className={`my-4 h-px ${isDarkShell ? 'bg-slate-700' : 'bg-slate-100'}`}
        />
        <div>
          {isLoading ? (
            <Loader />
          ) : (
            <div
              className={`${selectedTransactionId !== null ? 'overflow-hidden' : ''
                } ${scrollContainerClass}`}
            >
              <UniversalTransactions
                filteredTransactions={transactions}
                getColorAndIcon={getColorAndIcon}
                setSelectedTransactionId={setSelectedTransactionId}
                selectedTransactionId={selectedTransactionId}
                transactions={transactions}
                isBlurApplied={isBlurApplied}
                setIsBlurApplied={setIsBlurApplied}
                allTransactions={allTransactions}
                tableHeadingSelect={tableHeadingSelect}
                deleteType={deleteType}
                setModalDebtEditOpen={setModalDebtEditOpen}
                modalDebtEditOpen={modalDebtEditOpen}
                overDueType={overDueType}
                setIsOverdue={setIsOverdue}
                paidStatusMarker={paidStatusMarker}
                modalPaidStatus={modalPaidStatus}
              />
            </div>
          )}
        </div>
      </section>
    );
  }
  return isLoading && paidStatusMarker ? (
    ''
  ) : overDueType && isLoading ? (
    ''
  ) : (
    <section ref={divRef}>
      {paidStatusMarker ? (
        isLoading ? (
          ''
        ) : (
          <div className="mb-4">
            <SearchComponentPaidStatus
              iconDebt={iconDebt}
              debtType={debtType}
              debtParent={debtParent}
              getColorAndIcon={getColorAndIcon}
              currencySymbol={currencySymbol}
            />
          </div>
        )
      ) : overDueType ? (
        isLoading ? (
          ''
        ) : (
          <div className="mb-4">
            <p className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-[#FF7601]">
              {t('debts.overdueDebtsModal')}
            </p>
          </div>
        )
      ) : (
        !hideSearchForEmptyPlanning && (
          <div className="mt-3 mb-4">
            <Search searchValue={searchValue} setSearchValue={setSearchValue} />
          </div>
        )
      )}

      <div
        className={`my-4 h-px ${isDarkShell ? 'bg-slate-700' : 'bg-slate-100'}`}
      />
      <div>
        {isLoading ? (
          overDueType ? (
            ''
          ) : (
            <Loader />
          )
        ) : (
          <div
            className={`${selectedTransactionId !== null ? 'overflow-hidden' : ''} ${scrollContainerClass
              }`}
          >
            <UniversalTransactions
              filteredTransactions={filteredTransactions(
                transactions,
                searchValue
              )}
              getColorAndIcon={getColorAndIcon}
              setSelectedTransactionId={setSelectedTransactionId}
              selectedTransactionId={selectedTransactionId}
              transactions={transactions}
              isBlurApplied={isBlurApplied}
              setIsBlurApplied={setIsBlurApplied}
              allTransactions={allTransactions}
              tableHeadingSelect={tableHeadingSelect}
              deleteType={deleteType}
              setModalDebtEditOpen={setModalDebtEditOpen}
              modalDebtEditOpen={modalDebtEditOpen}
              overDueType={overDueType}
              paidStatusMarker={paidStatusMarker}
            />
          </div>
        )}
      </div>
    </section>
  );
};
